<div  class="flex-space-evenly flex-col" >
    <table *ngIf="name || tag || type" class="header-table">
        <tr>
            <td class="label">Name: </td>
            <td>
                <h4 class="item-name">{{ name }}</h4>
            </td>
            <td *ngIf="disabledSource" class="disabled-label">
                <strong
                    [attr.data-testid]="'disabled-text'"
                    class="disabled-source"
                >
                    {{ disabledSource }}
                </strong>
            </td>
        </tr>
        <tr *ngIf="tag">
            <td class="label">Tag: </td>
            <td>
                <h4 class="header-info" [attr.title]="tag"> {{ tag }}</h4>
            </td>
        </tr>
        <tr>
            <td *ngIf="type" class="label">Type: </td>
            <td *ngIf="type">
                <h4 class="header-info" [attr.type]="type"> {{ type }}</h4>
            </td>
            <div id="subtype-container">
                <td *ngIf="subType" class="label">Subtype: </td>
                <td *ngIf="subType">
                    <h4 id="subtype" class="header-info" [attr.type]="subType"> {{ subType }}</h4>
                </td>
            </div>
            <td *ngIf="featureScope !== 'Client'">
                <emm-locales-select
                    class="locale"
                    [languagesOnlyOfCountry]="countryCode"
                ></emm-locales-select>
            </td>
        </tr>
    </table>
</div>
